module.exports = __webpack_public_path__ + "static/img/公共安全馆.e4e074ac.png";